var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCountry10(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 124,
    viewBox: "0 0 131 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_344_544",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 131,
    height: 124
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 130.658,
    height: 124,
    rx: 33,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 129.658,
    height: 123,
    rx: 32.5,
    stroke: "#1E417C",
    strokeOpacity: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_344_544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.16016 84.5996H133.987V130.658H-4.16016V84.5996Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.16016 -7.49023H133.987V38.568H-4.16016V-7.49023Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.16016 38.5684H133.987V84.5996H-4.16016V38.5684Z",
    fill: "#DD0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry10);
export default __webpack_public_path__ + "static/media/country10.84ff94c11ab54080a1fddfd953705585.svg";
export { ForwardRef as ReactComponent };